(function () {
  if (!('IntersectionObserver' in window)) return;

  function applyReveal() {
    // Product cards
    document.querySelectorAll('.card-wrapper').forEach(function (el, i) {
      el.classList.add('reveal');
      el.style.transitionDelay = (i % 4 * 0.1) + 's';
    });

    // Section h2 headings (exclude header/nav)
    document.querySelectorAll('h2').forEach(function (el) {
      if (!el.closest('header') && !el.closest('nav')) {
        el.classList.add('reveal');
      }
    });

    // Brand story text column
    document.querySelectorAll('.brand-story__text-col').forEach(function (el) {
      el.classList.add('reveal');
    });

    // Observe all reveal elements
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.reveal').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyReveal);
  } else {
    applyReveal();
  }
})();
